import type { JSONDocNode, JSONNode } from '@atlaskit/editor-json-transformer/types';
import type { BlockNodeIdentifiers } from '@atlaskit/editor-synced-block-provider';

type JSONSyncBlockNode = {
	attrs: {
		resourceId: string;
		localId: string;
	};
	type: 'syncedBlock';
	marks?: any[];
};

const isSyncBlockNode = (node: JSONNode): node is JSONSyncBlockNode => {
	return (
		node.type === 'syncBlock' &&
		typeof node.attrs === 'object' &&
		node.attrs !== null &&
		'resourceId' in node.attrs &&
		'localId' in node.attrs &&
		typeof (node.attrs as any).resourceId === 'string' &&
		typeof (node.attrs as any).localId === 'string'
	);
};

/**
 * Extracts block identifiers (resourceId and blockInstanceId) from synced block nodes in an ADF document.
 * These identifiers are required for batch fetching synced blocks using the batchFetchData API.
 *
 * @param doc - The ADF document to extract synced block identifiers from
 * @returns Array of block node identifiers containing resourceId and blockInstanceId
 */
export function extractSyncBlockIdentifiers(doc: JSONDocNode): BlockNodeIdentifiers[] {
	const content = doc.content || [];

	return content.reduce<BlockNodeIdentifiers[]>((acc, node) => {
		if (isSyncBlockNode(node)) {
			acc.push({
				resourceId: node.attrs.resourceId,
				blockInstanceId: node.attrs.localId,
			});
		}
		return acc;
	}, []);
}
